// Single CDN project image (project B)
export const PROJECT_B_IMG =
  "https://assets.cdn.filesafe.space/iehMW4z3GZgoPjqmxz5p/media/6ab28834f07a3cb6d46c0e57.webp";
